module.exports = __webpack_public_path__ + "static/media/clip-1.6fd94c41.png";